import io from "socket.io-client";

export const socket = io("https://qbranch-hero6.herokuapp.com/journey")
//export const socket = io("https://qbranch-hero6-staging.herokuapp.com/journey");
//export const socket = io("http://localhost:5000/journey");